module.exports = __webpack_public_path__ + "021e07f954ddecdb17da26e9bc7ef284.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/mfizz/mfizz.woff
 ** module id = ./src/styles/fonts/mfizz/mfizz.woff
 ** module chunks = 0
 **/